import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=c49e2524"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=c49e2524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports